import { STATS } from "@/lib/brand";

const TICKER_ITEMS = [
  "ATL Esquadrias",
  "Alumínio & Vidro",
  "Fabricação Própria",
  "Florianópolis · SC",
  "Acabamento Premium",
  "Atendimento Personalizado",
  "Garantia de Qualidade",
  "Entrega no Prazo",
];

export const Stats = () => {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-[#facc15] text-black border-t border-b border-black/10 overflow-hidden"
    >
      {/* Marquee */}
      <div className="border-b border-black/15 overflow-hidden py-6">
        <div className="flex whitespace-nowrap marquee gap-12">
          {[...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS].map((t, i) => (
            <span
              key={i}
              className="font-display text-3xl sm:text-4xl italic tracking-tight"
            >
              {t} <span className="text-black/40 mx-6">✦</span>
            </span>
          ))}
        </div>
      </div>

      {/* Stats grid */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 grid grid-cols-1 sm:grid-cols-3 gap-8 lg:gap-12">
        {STATS.map((s, i) => (
          <div
            key={i}
            data-testid={`stat-${i}`}
            className="flex flex-col items-start"
          >
            <span className="text-4xl sm:text-5xl mb-3" aria-hidden>
              {s.icon}
            </span>
            <span className="font-display text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight">
              {s.value}
            </span>
            <span className="mt-3 text-[11px] uppercase tracking-[0.28em] font-bold text-black/70">
              {s.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};
